export const htmlStyles = {
	'h2:not(:first-of-type), h3:not(:first-of-type), h4:not(:first-of-type)': {
		mt: '2rem',
	},
	'h2, h3, h4': {
		mb: '0.3em',
	},
	h2: {
		fontSize: '2rem',
	},
	h3: {
		fontSize: '1.6rem',
	},
	h4: {
		fontSize: '1.2rem',
	},
	'p, ul': {
		mb: '0.6em',
	},
	p: {
		lineHeight: '1.75rem',
	},
	'ul, ol': {
		ml: '1.2rem',
	},
	a: {
		color: 'primary.500',
		'&:hover,&:focus': {
			color: 'primary.700',
		},
	},
	blockquote: {
		backgroundColor: 'secondary.50',
		borderLeft: '10px solid transparent', // adding color here does not work
		borderColor: 'primary.300',
		margin: '1.5em 10px',
		padding: '0.5em 10px',
		'&:before': {
			color: 'primary.300',
			content: 'open-quote',
			fontSize: '4em',
			lineHeight: '0.1em',
			marginRight: '0.1em',
		},
		'& > p': {
			display: 'inline',
		},
		'& > p:last-of-type': {
			display: 'block',
			marginTop: '1.8rem',
			fontSize: '1rem',
			'&:before': {
				content: "'- '",
			},
		},
	},
};
